import React from "react";
import { SectionHeaderWrapper } from "../../../../shared/SectionHeaderWrapper";
import {
  getLinkedAccountDetailAPIRequestLogsSettingsPathForId,
  getLinkedAccountDetailWebhookLogsSettingsPathForId,
} from "../../../../../router/RouterUtils";
import { LinkedAccount } from "../../../../../models/Entities";
import { Redirect, Route, Switch, useHistory, useLocation } from "react-router-dom";
import WebhookLogsPage from "../../../logs/pages/WebhooksLogsPage";
import LogsPage from "../../../logs/pages/LogsPage";
import { Switch as SwitchToggle } from "@merge-api/merge-javascript-shared";

type Props = {
  linkedAccount: LinkedAccount;
};

/**
 * Shows a few settings for the linked account itself. Always guaranteed to have content if there's a linked account
 */
const LinkedAccountLogsTab = ({ linkedAccount }: Props) => {
  const location = useLocation();
  const history = useHistory();
  const subtitle = location.pathname.startsWith(
    getLinkedAccountDetailAPIRequestLogsSettingsPathForId(linkedAccount.id),
  )
    ? "View API request logs related to this Linked Account"
    : "View webhook logs related to this Linked Account";

  const switchOptions = [
    {
      value: getLinkedAccountDetailAPIRequestLogsSettingsPathForId(linkedAccount.id),
      label: "API requests",
    },
    {
      value: getLinkedAccountDetailWebhookLogsSettingsPathForId(linkedAccount.id),
      label: "Webhooks",
    },
  ];

  const activeValue =
    switchOptions.find((opt) => location.pathname.startsWith(opt.value))?.value ??
    switchOptions[0].value;

  return (
    <>
      <SectionHeaderWrapper
        title={
          <div className="flex flex-row items-center gap-x-5">
            Logs
            <SwitchToggle
              options={switchOptions}
              value={activeValue}
              onChange={(value) => history.push(value)}
              size="sm"
            />
          </div>
        }
        subtitle={subtitle}
      >
        <Switch>
          <Route
            path={getLinkedAccountDetailAPIRequestLogsSettingsPathForId(linkedAccount.id)}
            render={(props) => <LogsPage {...props} linkedAccount={linkedAccount} />}
          />

          <Route
            path={getLinkedAccountDetailWebhookLogsSettingsPathForId(linkedAccount.id)}
            render={(props) => <WebhookLogsPage {...props} linkedAccount={linkedAccount} />}
          />

          <Redirect to={getLinkedAccountDetailAPIRequestLogsSettingsPathForId(linkedAccount.id)} />
        </Switch>
      </SectionHeaderWrapper>
    </>
  );
};

export default LinkedAccountLogsTab;
